// extracted by mini-css-extract-plugin
export var boxItems = "_ar-1";
export var boxItemsLg = "_ar-2";
export var button = "_ar-7";
export var buttonHoverless = "_ar-9";
export var buttonLg = "_ar-8";
export var filterGroupBox = "_ar-0";
export var icon = "_ar-3";
export var iconSecondary = "_ar-6";
export var iconWrapper = "_ar-4";
export var iconWrapperLg = "_ar-5";
export var truncatedLabel = "_ar-a";